import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import OpenInNewIcon from '@mui/icons-material/OpenInNewRounded';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import { authSelectors } from 'app-components/flux/auth';
import { profileActions } from 'app-components/flux/profile';
import { getEnvironmentConfig } from 'app-components/utils/core';

import VerifyPhone from 'assets/illustrations/Phone-and-Smile.svg';

const VerifyPhoneForIdentityVerification = (props) => {
  const { phoneNumber } = props;

  const dispatch = useDispatch();
  const theme = useTheme();

  const authSession = useSelector(authSelectors.getAuthSession);

  const openMyAccount = () => {
    dispatch(profileActions.createPhone());
    window.open(`${getEnvironmentConfig().myaccount_url}?hide-nav&bearer=${authSession.accessToken}`);
  };

  return (
    <Box display='flex' flexDirection='column' alignItems='center' width='100%' sx={{ textAlign: 'center' }}>
      <Typography>Before we start we need to verify your phone number.</Typography>
      <Box display='flex' alignItems='center' mt={2} mb={2}>
        <img style={{ marginRight: 50 }} src={VerifyPhone} alt='phone-check' />
        <Box textAlign='left' ml={1}>
          <Typography variant='paragraphRegular' color='textSecondary'>
            Phone number
          </Typography>
          <Typography>{phoneNumber}</Typography>
        </Box>
      </Box>
      <Box mt={5} px={4} width={700}>
        <Typography variant='paragraphRegular' color='textSecondary'>
          We&apos;ll send a verification text to your phone for you to tap. Not the correct phone number? You can change
          it in&nbsp;
          <Typography
            component='span'
            onClick={openMyAccount}
            sx={{ color: theme.palette.primary.main, cursor: 'pointer' }}
            variant='inherit'
          >
            My Account&nbsp;
            <OpenInNewIcon style={{ fontSize: 'inherit' }} />
          </Typography>
        </Typography>
      </Box>
    </Box>
  );
};
VerifyPhoneForIdentityVerification.propTypes = {
  phoneNumber: PropTypes.string,
};

export default VerifyPhoneForIdentityVerification;
